<template>
  <div style="width: 100%; height: 100%; position: relative">

<div id="mapicon" @click="openjiupian">{{isjiupian?'取消纠偏':'轨迹纠偏'}}</div>
    <now-data
      :data="otherData"
      :curentPoint="curentPoint"
      v-if="gpsData.length > 0"
      v-show="!isjiupian"
    >
    <template slot="address">{{address}}</template>
    </now-data>
    <div id="mymaplocus" v-show="!isjiupian"></div>
    <jiupian ref="jiupian" v-show="isjiupian"></jiupian>
    
    <div id="playLocus" v-show="!isjiupian">
      <play
        @parentFn="play"
        @changeSpeed="reSpeed"
        @changeSlider="reSlider"
        ref="slider"
        v-if="gpsData.length > 0"
      ></play>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import play from "./play";
import nowData from "./nowData";
import jiupian from "./grasproad.vue"
var map;
var pointMarkers = [];
var navg0;
var set; //设置定时器
var parks=[];
var infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(0, -30) });
export default {
  data() {
    return {
      openControl: false,
      carSpeed: 500, //播放速度
      gpsData: [], //定位数据
      otherData: [], //其他数据
      split2: 0.8, //面板
      startPoint: 0, //轨迹车俩初始停留点。为了点击详细列表反查车龄停留在哪用到，默认停留在起点
      curentPoint: 0, //节点位置
      getPosition: 0, //巡航器真是经纬度
      address:'',
      isjiupian:false
    };
  },
  components: {
    play,
    nowData,
    jiupian
  },
  methods: {
    getHistory(time) {
      this.openControl = false;
      var params = {
        deviceId: this.$store.state.carMsg.deviceId,
        startTime: time.start.getTime(),
        endTime: time.end.getTime(),
      };
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.serverWeb + "/locus/list",
        data: params,
      })
        .then((res) => {
          this.$Spin.hide(); //关闭加载
          this.gpsData = [];
          this.otherData = [];
          var data = res.data.data.dataList;
          this.$store.state.control = true;
          map && map.destroy();
          this.myMap();
          if (data.length == 0) {
            return;
          }
          for (let i = 0; i < data.length; i++) {
            var arr = [data[i].gcj02x, data[i].gcj02y];
            this.gpsData.push(arr);
            data[i].acc=data[i].accStatus==0?"关":"开";
            data[i].tm = data[0].gpsTime/1000;
            data[i].tms = data[i].gpsTime/1000;
            data[i].gpsTime = this.utils.time(data[i].gpsTime);
              data[i].reportTime = this.utils.time(data[i].reportTime);
              data[i].startParkTime = this.utils.time(data[i].startParkTime);
              data[i].endParkTime = this.utils.time(data[i].endParkTime);
          }
          this.otherData=data;
          //从定位板块点击近来的车会立即开启轨迹查询。查完了要置为false。其他方式不自动查轨迹
          this.$store.state.carMsg.lookLocusNow == false;
          this.loadUi();
          this.jiexi(data[this.curentPoint]);
        })
    },
    //加载高德ui轨迹
    loadUi() {
      var that = this;
      AMapUI.load(["ui/misc/PathSimplifier"], function (PathSimplifier) {
        if (!PathSimplifier.supportCanvas) {
          alert("当前环境不支持 Canvas！");
          return;
        }
        //启动页面
        that.initMap(PathSimplifier);
        that.startEndPoint();
      });
      this.showpark(this.otherData,10);
    },
    //初始化轨迹
    initMap(PathSimplifier) {
      var that = this;
      var pathSimplifierIns = new PathSimplifier({
        zIndex: 100,
        map: map, //所属的地图实例
        getPath: function (pathData, pathIndex) {
          //返回轨迹数据中的节点坐标信息，[AMap.LngLat, AMap.LngLat...] 或者 [[lng|number,lat|number],...]
          return pathData.path;
        },

        getHoverTitle: function (pathData, pathIndex, pointIndex) {
          //鼠标悬停在节点之间的连线上
          return pointIndex == undefined
            ? false
            : "编号：" +
                Number(pointIndex + 1) +
                "<br>时间：" +
                that.otherData[pointIndex].time +
                "<br>地址：" +
                that.otherData[pointIndex].address +
                "<br>速度：" +
                that.otherData[pointIndex].speed +
                "公里/小时" +
                "<br>里程：" +
                that.otherData[pointIndex].miledata +
                "公里";
        },
        renderOptions: {
          //轨迹线的样式
          pathLineStyle: {
            strokeStyle: "#15ad2e",
            lineWidth: 6,
            dirArrowStyle: true,
          },
          //鼠标经过线的样式
          pathLineHoverStyle: {
            strokeStyle: "#15ad2e",
            lineWidth: 6,
            dirArrowStyle: true,
          },
          //选中的样式
          pathLineSelectedStyle: {
            strokeStyle: "#15ad2e",
            lineWidth: 6,
            dirArrowStyle: true,
          },
          //一次加载点个数
          renderAllPointsIfNumberBelow: 1000,
          //关键点样式
          keyPointStyle: {
            radius: 0,
            fillStyle: "blue",
            strokeStyle: "blue",
            lineWidth: 2,
          },
          //鼠标经过关键点样式
          keyPointHoverStyle: {
            radius: 4,
            fillStyle: "blue",
            strokeStyle: "blue",
            lineWidth: 1,
          },
        },
      });

      //这里构建两条简单的轨迹，仅作示例
      pathSimplifierIns.setData([
        {
          name: "活动轨迹",
          path: this.gpsData,
        },
      ]);
      /* pathSimplifierIns.on("pathClick pointClick", function(e, info) {
        console.log(info);
      }); */
      pathSimplifierIns.on("pathMouseover", function (e, info) {});
      pathSimplifierIns.setFitView();
      //创建一个巡航器

      var content = PathSimplifier.Render.Canvas.getImageContent(
        "static/car/3/1.gif",

        function onload() {
          //图片加载成功，重新绘制一次

          pathSimplifierIns.renderLater();
        }
      );
      navg0 = pathSimplifierIns.createPathNavigator(
        0, //关联第1条轨迹
        {
          loop: true, //循环播放
          speed: this.carSpeed,
          pathNavigatorStyle: {
            width: 30,
            height: 30,
            content: content,
          },
        }
      );
      /* //移动牌
      navg0.marker = new AMap.Marker({
        offset: new AMap.Pixel(12, -10),
        content: "<div>当前速度 :" + navg0.getSpeed() + "</div>", //设置当前点信息窗口显示内容
        map: map
      }); */
      navg0.on("move", function (e) {
        that.getPosition = navg0.getPosition();
        //navg0.marker.setPosition(navg0.getPosition());//移动牌
        //console.log(navg0.getCursor());
        var cursor = navg0.getCursor();

        that.curentPoint = Math.round(cursor.idx);

        that.$refs.slider.changeCurentPoint(
          that.curentPoint,
          that.gpsData.length
        );
      });
    },
    //初始化轨迹起点，用在点击列表反查车辆位置
    reDrawPoint(x) {
      var marker = new AMap.Marker({
        map: map,
        position: [x.lng, x.lat],
        icon: "static/car/1_" + x.direction + ".gif",
        offset: new AMap.Pixel(-2, -15),
        autoRotation: true, //自动转弯
        angle: -90,
      });
      markers.push(marker);

      for (let i = 0; i < markers.length; i++) {
        markers[i].setMap(null);
      }

      map.add(marker);
      map.setFitView(); //视野居中
    },
    //初始化地图
    myMap() {
      map = new AMap.Map("mymaplocus", {
        resizeEnable: true,
        center: [114.404, 22.905],
        zoom: 14,
      });
      //map.setMapStyle("amap://styles/normal");
      // map.setMapStyle('amap://styles/blue');
      // map.setMapStyle('amap://styles/1f78cffcf98ec7b47795bab6c83b1cc4');
    },
    selectCar() {
      this.openControl = true;
    },
    play(val) {
      switch (val) {
        case 1: //播放
          navg0.start(this.startPoint);
          //console.log(this.gpsData[Math.round(this.curentPoint)])
          set = setInterval(() => {
            map.panTo(this.getPosition);
          }, this.carSpeed);
          this.address='暂停可看地址';
          break;
        case 2: //暂停
          navg0.pause();
          clearInterval(set);
          this.jiexi(this.otherData[this.curentPoint]);
          break;
        case 3: //继续
          navg0.resume();
          set = setInterval(() => {
            map.panTo(this.getPosition);
          }, this.carSpeed);
          
          this.address='暂停可看地址';
          break;
        case 4: //销毁
          navg0.destroy();
          break;
      }
    },
    //起点和终点
    startEndPoint(v) {
      map.remove(pointMarkers);
      var m = 0;
      for (var i = 0, marker; i < this.gpsData.length; i++) {
        if (i == 0 || i == this.gpsData.length - 1) {
          i == 0 ? (m = 0) : (m = 1);
          var icon = new AMap.Icon({
            size: new AMap.Size(100, 100), // 图标尺寸
            image: "static/" + m + ".gif", // Icon的图像
            imageOffset: new AMap.Pixel(0, 0), // 图像相对展示区域的偏移量，适于雪碧图等
            imageSize: new AMap.Size(24, 32), // 根据所设置的大小拉伸或压缩图片
          });
          var marker = new AMap.Marker({
            position: this.gpsData[i],
            icon: icon,
            map: map,
            offset: new AMap.Pixel(-12, -36),
          });
        }
      }

      // pointMarkers.push(marker);

      map.setFitView();
      setTimeout(() => {}, 50);
    },
    //接受到的速度
    reSpeed(s) {
      this.carSpeed = s * 100;
      navg0.setSpeed(this.carSpeed);
      //this.play(1);
    },
    //移动滑块。轨迹小车移动到指定点
    reSlider(n) {
      this.curentPoint = Number(this.gpsData.length - 1) * n * 0.01;
      navg0.moveToPoint(Math.round(this.curentPoint), 0.2);
    },
    closeMap() {
      this.$store.state.control = false;
      this.$store.state.carMsg = {
        deviceId: "",
        carNum: "",
        userId: "",
        play: 1,
      };
      this.$store.state.startTime = ""; //轨迹开始时间
      this.$store.state.endTime = ""; //轨迹结束时间
      map && map.destroy();
      clearInterval(set);
      if (this.otherData.length > 0) {
        this.play(4);
      }
      this.$emit("closeMap");
    },
    showpark(v, m) {
      map.remove(parks);
      parks = [];
      var k = 1;
      for (var i = 0, marker; i < v.length; i++) {
        var icon = new AMap.Icon({
          //size: new AMap.Size(20, 26), // 图标尺寸
          image: "static/park.png", // Icon的图像
          imageOffset: new AMap.Pixel(6, 10), // 图像相对展示区域的偏移量，适于雪碧图等
          imageSize: new AMap.Size(12, 18), // 根据所设置的大小拉伸或压缩图片
        });
        if (v[i].parkDuration > m) {
          marker = new AMap.Marker({
            map: map,
            position: [v[i].gcj02x, v[i].gcj02y],
            icon: icon,
          });
          marker.content =
            "<div><p>停车标记：第" +
            k +
            "停车点</p><p>停车时长：" +
            this.utils.minTime(v[i].parkDuration) +
            "</p><p>开始停车：" +
            v[i].startParkTime +
            "</p><p>结束停车：" +
            v[i].endParkTime +
            "</p></div>";
          k++;

          marker.on("click", markerClick);
          parks.push(marker);
        }
      }

      map.add(parks);
      function markerClick(e) {
        infoWindow.setContent(e.target.content);
        infoWindow.open(map, e.target.getPosition());
      }
    },
    jiexi(v) {
      var pointList = [
        {
          x: v.gcj02x,
          y: v.gcj02y,
        },
      ];
      this.utils.jiexi(pointList).then((data) => {
        this.address = data[0].address;
      });
    },
    openjiupian(){
      this.isjiupian=!this.isjiupian;
      console.log(this.isjiupian);
      if (this.isjiupian) {
        console.log(this.otherData);
        this.$refs.jiupian.jiupian(this.otherData);
      } else {
        
      }
      
    }
  },
  mounted() {
    this.myMap();
  },
  destroyed() {
    this.$store.state.control = false;
    this.$store.state.carMsg = {
      carId: "",
      carNum: "",
      userId: "",
      play: 1,
    };
    this.$store.state.startTime = ""; //轨迹开始时间
    this.$store.state.endTime = ""; //轨迹结束时间
    map && map.destroy();
    clearInterval(set);
    if (this.otherData.length > 0) {
      this.play(4);
    }
  },
};
</script>
<style lang="">
#mymaplocus {
  width: 100%;
  height: 100%;
}
#mapicon {
  position: absolute;
  bottom: 70px;
  right: 0;
  background: rgba(0, 0, 0, .3);
  z-index: 32;
  color: #fff;
  padding:4px 10px;
  text-align: center;
  /* background-image: -webkit-gradient(linear,left top, left bottom,from(rgba(255,255,255,0)),color-stop(70%, #fff));
background-image: linear-gradient(-180deg,rgba(255,255,255,0) 0%,#fff 70%); */
}
#playLocus {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 222;
  width: 100%;
  background: #fff;
  border-top: solid 1px #999;
}
</style>


// WEBPACK FOOTER //
// src/components/locus/map.vue